import React, { useEffect, useState } from 'react';
import { Link, Redirect } from "react-router-dom";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import MenuVertical from '../../layouts/MenuVertical';
import { Grid, Icon, Button, Loader } from "semantic-ui-react";
import Votacao, { statusVotacao } from './Votacao';
import CondominioVencido from '../admin/CondominioVencido';
import api from '../../../api';

const Votacoes = ({ match: { params } }) => {
  const [condominio, setCondominio] = useState({});
  const [votacoes, setVotacoes] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [filtro, setFiltro] = useState('todas');

  useEffect(
    () => {
      const init = async () => {
        try {
          const cond = await api.condominio.findSimpleById(params.id);
          setCondominio(cond);
          loadVotacoes(cond);
        } catch (e) {
          setErrors((e.data && e.data.errors) || {});
        }

        setLoading(false);
      };
      init();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const loadVotacoes = async (cond) => {
    try {
      const votacoesRes = await api.votacao.find(cond ? cond._id : condominio._id).then(it => it.votacoes);
      setVotacoes(votacoesRes);
    } catch (e) {
      setErrors((e.data && e.data.errors) || {});
    }
  };

  const visiveis = votacoes.filter(v =>
    (filtro === 'todas' || statusVotacao(v).chave === filtro) &&
    (!busca.trim() || (v.titulo || '').toLowerCase().includes(busca.trim().toLowerCase()))
  );
  const contar = chave => votacoes.filter(v => statusVotacao(v).chave === chave).length;

  const getList = votacoes =>
    !!votacoes.length ? (
      <Grid columns={3} doubling stackable style={{ marginTop: "20px" }}>
        {votacoes.map(votacao =>
          <Grid.Column key={votacao._id}>
            <Votacao votacao={votacao} atualizarLista={loadVotacoes} />
          </Grid.Column>
        )}
      </Grid>
    ) : (
      <div className="empty-illustration-1">
        <img src="/images/illustrations/urna-votacao.svg" alt="Nenhuma votação encontrada" />
        {votacoes.length > 0 && <p style={{ textAlign: 'center' }}>Nenhuma votação com esse filtro.</p>}
      </div>
    );

  return (
    <>
      {!!errors.global && <Redirect to="/" />}
      <MenuHorizontal />
      <div className="corpo-dashboard">
        <MenuVertical condominio={condominio} />
        <header className="va-un-cabecalho">
          <h1>Votações</h1>
          <p>Crie assembleias, acompanhe o andamento e emita os relatórios.</p>
        </header>
        <div className="va-un-barra-acoes">
          <CondominioVencido condominio={condominio}>
            <Button
              className="btn-ui-1"
              as={Link}
              to={`/condominios/${condominio._id}/votacoes/cadastrar`}
              size="large"
            >
              <Icon name="plus" /> Cadastrar Votação
            </Button>
          </CondominioVencido>
        </div>
        <div className="va-un-filtros">
          <div className="va-un-busca">
            <Icon name="search" />
            <input type="search" placeholder="Buscar votação pelo título" value={busca} onChange={e => setBusca(e.target.value)} aria-label="Buscar votação" />
          </div>
          <div className="va-un-abas" role="tablist">
            {[
              ['todas', 'Todas', votacoes.length],
              ['andamento', 'Em andamento', contar('andamento')],
              ['bloqueada', 'Bloqueadas', contar('bloqueada')],
              ['finalizada', 'Finalizadas', contar('finalizada')],
            ].map(([chave, rotulo, qtd]) => (
              <button type="button" role="tab" aria-selected={filtro === chave} key={chave} className={filtro === chave ? 'ativo' : ''} onClick={() => setFiltro(chave)}>
                {rotulo} <span>{qtd}</span>
              </button>
            ))}
          </div>
        </div>
        {loading ? (
          <Loader active inline='centered' style={{ marginTop: "50px" }} />
        ) : getList(visiveis)}
      </div>
    </>
  );
};

export default Votacoes;
